/**
 * React Compiler 互換のハッシュナビゲーション。
 * コンポーネント内で `window.location.hash` を直接書き換えると
 * 「Writing to a variable defined outside a component or hook」警告が発生するため、
 * 関数呼び出しでラップして回避する。
 */
export function navigateToHash(hash: string) {
  window.location.hash = hash;
}